export default "__VITE_ASSET__D662odhJ__"